<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Alasan Hapus Akun</div>
        </div>
        <div id="appCapsule">
            <div
                class="section inset mt-2"
                style="font-size:13px;line-height:20px;"
            >
                <p>
                    Yaah.. Kita akan berpisah, deh. Bantu kami jadi lebih baik
                    dengan ceritain alasanmu hapus akun, ya.
                </p>
            </div>
            <div
                class="section inset mt-2"
                style="font-size:13px;line-height:20px;"
            >
                <h4>Kenapa kamu mau hapus akun:</h4>
                <div class="input-list">
                    <div class="custom-control custom-radio">
                        <input
                            type="radio"
                            id="Tidak pakai akun ini lagi"
                            name="customRadioList"
                            class="custom-control-input"
                            value="Tidak pakai akun ini lagi"
                            v-model="data_delete_account.reason_option"
                        />
                        <label
                            class="custom-control-label"
                            for="Tidak pakai akun ini lagi"
                            >Tidak pakai akun ini lagi</label
                        >
                    </div>
                    <div class="custom-control custom-radio">
                        <input
                            type="radio"
                            id="Punya akun lain<"
                            name="customRadioList"
                            class="custom-control-input"
                            value="Punya akun lain"
                            v-model="data_delete_account.reason_option"
                        />
                        <label
                            class="custom-control-label"
                            for="Punya akun lain<"
                            >Punya akun lain</label
                        >
                    </div>
                    <div class="custom-control custom-radio">
                        <input
                            type="radio"
                            id="Ada masalah privasi & keamanan akun"
                            name="customRadioList"
                            class="custom-control-input"
                            value="Ada masalah privasi & keamanan akun"
                            v-model="data_delete_account.reason_option"
                        />
                        <label
                            class="custom-control-label"
                            for="Ada masalah privasi & keamanan akun"
                            >Ada masalah privasi & keamanan akun</label
                        >
                    </div>
                    <div class="custom-control custom-radio">
                        <input
                            type="radio"
                            id="Lainnya"
                            name="customRadioList"
                            class="custom-control-input"
                            value="Lainnya"
                            v-model="data_delete_account.reason_option"
                        />
                        <label class="custom-control-label" for="Lainnya"
                            >Lainnya</label
                        >
                    </div>
                </div>
                <div class="form-group boxed">
                    <textarea
                        style="font-size:13px;"
                        class="form-control"
                        rows="2"
                        v-model="data_delete_account.reason_detail"
                        placeholder="Ceritain kami lebih detail"
                    ></textarea>
                </div>
            </div>
            <div class="form-button-group transparent">
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="showDialog('show')"
                    style="height: 45px;"
                    :disabled="
                        data_delete_account.reason_option == '' ||
                            data_delete_account.reason_detail == ''
                    "
                >
                    Lanjut
                </button>
            </div>
        </div>
        <Dialog
            ref="dialog"
            :loading="dialogLoading"
            :title="'Yakin mau hapus akun?'"
            @confirm="verifyWithPin()"
        >
            <p>
                Pastikan kamu sudah cek semua hal yang akan terjadi jika akun
                dihapus, karena akunmu tidak bisa dikembalikan.
            </p>
        </Dialog>
        <action-sheet-sender
            ref="sender"
            :phone="customer.phone"
            :inset="true"
        ></action-sheet-sender>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import $axios from './../../../api.js';
    export default {
        props: ['toast_reference'],
        data() {
            return {
                loadingContent: true,
                dialogLoading: false,
                data_delete_account: {
                    reason_option: '',
                    reason_detail: '',
                },
            };
        },
        created() {
            setTimeout(() => (this.loadingContent = false), 500);
        },
        methods: {
            showDialog(value) {
                let element = this.$refs.dialog.$el;
                window.$(element).modal(value);
            },
            verifyWithPin() {
                this.showDialog('hide');
                this.$router.push({
                    name: 'auth.pin.verify',
                    params: {
                        data_reference: this.data_delete_account,
                        url_reference: '/request-delete-account',
                        previous_page_reference: 'account.delete.form',
                        next_page_reference: 'account.delete.form',
                    },
                });
            },
            submit() {
                this.dialogLoading = true;
                $axios
                    .post('/request-delete-account', this.data_delete_account)
                    .then(response => {
                        this.showDialog('hide');
                        this.dialogLoading = false;
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: response.data.message,
                            tipe: 'default',
                            icon: 'success',
                        });
                        this.$router.push({ name: 'account' });
                    })
                    .catch(error => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.showDialog('hide');
                        this.dialogLoading = false;
                    });
            },
        },
        computed: {
            ...mapState(['VUE_ENV', 'customer', 'toast']),
        },
        mounted() {
            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    this.$store.commit('SET_TOAST', this.toast_reference);
                }
                this.$store.commit('SET_LOADING', { app: false });
            }, 500);
        },
    };
</script>
